/* eslint-disable */
import {
  Filter,
  Matrix
} from 'pixi.js';

const vertex = `
  attribute vec2 aVertexPosition;

  uniform mat3 projectionMatrix;
  uniform mat3 filterMatrix;

  varying vec2 vTextureCoord;
  varying vec2 vFilterCoord;

  uniform vec4 inputSize;
  uniform vec4 outputFrame;

  vec4 filterVertexPosition( void ) {
      vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

      return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
  }

  vec2 filterTextureCoord( void ) {
      return aVertexPosition * (outputFrame.zw * inputSize.zw);
  }

  void main(void) {
    gl_Position = filterVertexPosition();
    vTextureCoord = filterTextureCoord();
    vFilterCoord = ( filterMatrix * vec3( vTextureCoord, 1.0)  ).xy;
  }
`

const fragment = `
  varying vec2 vFilterCoord;
  varying vec2 vTextureCoord;

  uniform vec2 speed;
  uniform mat2 rotation;
  uniform sampler2D uSampler;
  uniform sampler2D mapSampler;
  uniform sampler2D trail;

  uniform highp vec4 inputSize;
  uniform vec4 inputClamp;

  void main(void) {
    vec4 map = texture2D(mapSampler, vFilterCoord);

    map -= 0.5;
    map.xy = (texture2D(trail, vTextureCoord).rg * speed) * inputSize.zw * (rotation * map.xy);

    gl_FragColor = texture2D(uSampler, clamp(vec2(vTextureCoord.x + map.x, vTextureCoord.y + map.y), inputClamp.xy, inputClamp.zw));
  }
`

class WaterEffect extends Filter {
  constructor(sprite, trail, speed, scale) {
    const maskMatrix = new Matrix();
    sprite.renderable = false;
    trail.renderable = false;
    super(vertex, fragment, {
      mapSampler: sprite._texture,
      filterMatrix: maskMatrix,
      scale: { x: 1, y: 1 },
      rotation: new Float32Array([1, 0, 0, 1]),
    });

    this.maskSprite = sprite;
    this.maskMatrix = maskMatrix;
    this.scale = scale;
    
    this.uTrail = trail;
    this.uSpeed = speed;

    this.uniforms.speed = { x: 0, y: 0 };
  }

  apply(filterManager, input, output, clear) {
    this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, this.maskSprite);
    this.uniforms.trail = this.uTrail._texture;
    this.uniforms.speed.x = (1 + this.uSpeed.x) * this.scale;
    this.uniforms.speed.y = (1 + this.uSpeed.y) * this.scale;

    const wt = this.maskSprite.transform.worldTransform;
    const lenX = Math.sqrt((wt.a * wt.a) + (wt.b * wt.b));
    const lenY = Math.sqrt((wt.c * wt.c) + (wt.d * wt.d));

    if (lenX !== 0 && lenY !== 0) {
        this.uniforms.rotation[0] = wt.a / lenX;
        this.uniforms.rotation[1] = wt.b / lenX;
        this.uniforms.rotation[2] = wt.c / lenY;
        this.uniforms.rotation[3] = wt.d / lenY;
    }

    filterManager.applyFilter(this, input, output, clear);
  }

  get speed() {
    return this.speed;
  }

  set speed(speed) {
    this.uSpeed.x = speed.x;
    this.uSpeed.y = speed.y;
  }
}

export default WaterEffect;
